var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.47716 4.47715 0 10 0H108C113.523 0 118 4.47715 118 10V114H0V10Z",
  fill: "#8639C9",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59 90C76.6731 90 91 75.6731 91 58C91 40.3269 76.6731 26 59 26C41.3269 26 27 40.3269 27 58C27 75.6731 41.3269 90 59 90Z",
  fill: "#BE7BEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.9676 59.4037L64.9711 33.4072L42.3381 69.0729L49.2115 75.9739L46.0879 83.0662L52.348 89.3059C54.4943 89.7596 56.7189 90.0001 59 90.0001C76.2026 90.0001 90.2326 76.4254 90.9676 59.4037Z",
  fill: "#8639C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.3259 52.0127L44.2034 56.3827C40.8391 57.9943 39.0919 61.7666 40.0383 65.3749C40.0618 65.4646 40.0868 65.5534 40.1133 65.6417C40.8281 68.0203 42.677 69.8037 44.9424 70.5583C45.8253 70.8524 51.483 65.3546 51.483 65.3546L53.3259 52.0127Z",
  fill: "#FFD097"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.0396 52.0127L74.162 56.3827C77.5263 57.9943 79.2735 61.7666 78.3272 65.3749C78.3037 65.4646 78.2787 65.5534 78.2522 65.6417C77.5373 68.0203 75.6884 69.8037 73.423 70.5583C72.54 70.8524 66.9595 65.5683 66.9595 65.5683L65.0396 52.0127Z",
  fill: "#FFC473"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.7387 70.9463L54.3979 70.643L54.0937 65.3545C50.8907 65.6477 47.8508 66.2131 45.0518 67.007C43.3008 67.5036 43.2161 69.9821 44.9428 70.5579C45.8254 70.8523 46.7716 70.9903 47.7387 70.9463Z",
  fill: "#FFB74F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.1113 72.7204L50.5785 65.7471L48.3685 66.1981L47.2841 72.7204C47.2025 73.7772 46.9038 74.8057 46.4066 75.7418L45.4287 77.5828C44.4803 79.3683 44.7432 81.5553 46.0878 83.0652C48.0103 85.2241 51.3853 85.2241 53.3078 83.0652C54.6523 81.5553 54.9153 79.3683 53.967 77.5828L52.9891 75.7418C52.4917 74.8057 52.193 73.7772 52.1113 72.7204Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.6267 70.9463C71.5938 70.9903 72.5399 70.8523 73.4227 70.5579C75.1493 69.9821 75.0647 67.5036 73.3137 67.007C70.5147 66.2131 67.4748 65.6477 64.2718 65.3545L63.9675 70.643L70.6267 70.9463Z",
  fill: "#FFAA20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.9867 75.4594C54.8467 75.4594 51.4178 72.2596 51.0512 68.2108C50.9962 67.6039 47.0903 54.6213 47.0903 54.6213L50.5456 40.5761C50.7887 39.5878 50.9541 38.5834 51.0918 37.5751C51.6218 33.6974 54.9695 30.6846 58.9867 30.6846C63.0038 30.6846 66.3516 33.6974 66.8816 37.5751C67.0525 38.8254 67.335 40.0579 67.6645 41.2761L71.275 54.6213C71.275 54.6213 66.9798 67.6533 66.9133 68.3032C66.5033 72.3081 63.0952 75.4594 58.9867 75.4594Z",
  fill: "#FFDBA9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.2749 54.6213C71.2749 54.6213 66.9799 67.6537 66.9136 68.3037C66.5099 72.245 63.2024 75.3587 59.1824 75.4575V30.6875C61.1149 30.735 62.8824 31.4775 64.2411 32.6762C65.6474 33.9137 66.6161 35.6362 66.8811 37.575C67.0524 38.8263 67.3349 40.0588 67.6649 41.2762L71.2749 54.6213Z",
  fill: "#FFD097"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "white",
  transform: "translate(27 26)"
})));
function SvgSymptomRunnyNose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomRunnyNose);
export default __webpack_public_path__ + "static/media/symptom-Runny-Nose.040df9241be683d220a10e8bf3f90b2d.svg";
export { ForwardRef as ReactComponent };